import { render, staticRenderFns } from "./TableauSiteAssetsTreeItem.vue?vue&type=template&id=52cbfd64&"
import script from "./TableauSiteAssetsTreeItem.vue?vue&type=script&lang=js&"
export * from "./TableauSiteAssetsTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TableauSiteAssetsTreeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports